const AccessTokenKey = 'Access-Token';
const RefreshTokenKey = 'Refresh-Token';
const LoggedUserKey = 'LoggedUserInfo';
const VehiclesKey = 'VehiclesKey';
const NotificattionToken = 'Notificattion-Token';
const CodeZaloUser = 'CodeZaloUser';
import Cookies from 'js-cookie';

export function getAccessToken () {

  let token = localStorage.getItem(AccessTokenKey);

  // if (!token) {
  //   setStoreVehicles([]);
  //   window.location.href = '#/login';
  // }

  return token ? token : Cookies.get(AccessTokenKey);
}

export function setAccessToken (token) {
  localStorage.setItem(AccessTokenKey, token);
  return Cookies.set(AccessTokenKey, token);
}

export function getRefreshToken () {
  let token = localStorage.getItem(RefreshTokenKey);

  // if (!token) {
  //   setStoreVehicles([]);
  //   window.location.href = '#/login';
  // }

  return token ? token : Cookies.get(RefreshTokenKey);
}

export function setRefreshToken (token) {
  localStorage.setItem(RefreshTokenKey, token);
  return Cookies.set(RefreshTokenKey, token);
}

export function getLoggedUser () {
  let userFromLocalStorage = localStorage.getItem(LoggedUserKey);
  let userFromCookie = Cookies.get(LoggedUserKey);

  // if (!userFromLocalStorage && !userFromCookie) {
  //   setStoreVehicles([]);
  //   window.location.href = '#/login';
  // }

  return userFromLocalStorage
    ? JSON.parse(userFromLocalStorage)
    : userFromCookie
      ? JSON.parse(userFromCookie)
      : null;
}

export function setLoggedUser (user) {
  let json = JSON.stringify(user);
  localStorage.setItem(LoggedUserKey, json);
  return Cookies.set(LoggedUserKey, json);
}

export function getStoreVehicles () {
  let vehiclesFromLocalStorage = localStorage.getItem(VehiclesKey);
  let vehiclesFromCookie = Cookies.get(VehiclesKey);

  return vehiclesFromLocalStorage
    ? JSON.parse(vehiclesFromLocalStorage)
    : vehiclesFromCookie
      ? JSON.parse(vehiclesFromCookie)
      : null;
}

export function setStoreVehicles (vehicles) {
  let json = JSON.stringify(vehicles);
  localStorage.setItem(VehiclesKey, json);
  return Cookies.set(VehiclesKey, json);
}

export function removeToken () {
  localStorage.removeItem(RefreshTokenKey);
  localStorage.removeItem(AccessTokenKey);
  localStorage.removeItem(LoggedUserKey);
  localStorage.removeItem(VehiclesKey);

  Cookies.remove(RefreshTokenKey);
  Cookies.remove(LoggedUserKey);
  Cookies.remove(VehiclesKey);

  return Cookies.remove(AccessTokenKey);
}

export function getNotificationToken () {
  let token = localStorage.getItem(NotificattionToken);
  return token ? token : Cookies.get(NotificattionToken);
}

export function setNotificationToken (token) {
  localStorage.setItem(NotificattionToken, token);
  return Cookies.set(NotificattionToken, token);
}

export function removeNotificationToken () {
  console.log('remove token');
  localStorage.removeItem(NotificattionToken);
  Cookies.remove(NotificattionToken);
}

export function getCodeZaloUser () {
  let token = localStorage.getItem(CodeZaloUser);
  return token ? token : Cookies.get(CodeZaloUser);
}

export function setCodeZaloUser (token) {
  localStorage.setItem(CodeZaloUser, token);
  return Cookies.set(CodeZaloUser, token);
}

export function removeCodeZaloUser (token) {
  localStorage.removeItem(CodeZaloUser, token);
  return Cookies.remove(CodeZaloUser, token);
}




// WEBPACK FOOTER //
// ./src/utils/auth.js